<div class="zest-wrapper">
  <div class="zest-load-wrapper">
    <div >
      <h1>Redirecting support user</h1>
    </div>
    <div class="middle spinner-container" *ngIf="isLoadingHotels | async">
      <mat-spinner [diameter]="100" class="grey"></mat-spinner>
    </div>
  </div>
</div>
